import React, { useState } from 'react';
import { StyledDuplicatePopup } from './StyledDuplicatePopup';
import { Button, Checkbox, Select } from 'antd';
import { useDispatch } from 'react-redux';
import Notification from 'dorothy/utils/alert';

import { DUPLICATE_POST_REQUEST } from '../constant';
const { Option } = Select;

const DuplicatePopup = ({ postId, urlTitle, postLanguage, onClose, dbName }) => {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(true);

  const onValidate = async ({ postId, urlTitle, languageTo }) => {
    const request = {
      postId,
      urlTitle,
      languageTo,
    };
    const res = await fetch(`/api/posts/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    const { data } = await res.json();
    return data;
  };

  const handleDuplicate = async () => {
    const isValid = await onValidate({
      postId: postId,
      urlTitle: urlTitle,
      languageTo: language,
    });
    if (!isValid) {
      return Notification.error('URL Title already exists');
    }

    const isSuccess = await dispatch({
      type: DUPLICATE_POST_REQUEST,
      payload: {
        id: postId,
        language,
        isReplaceLink: checked,
      },
    });
    if (isSuccess) {
      Notification.success('Post duplicated successfully!');
    }
    onClose();
  };

  let languageOptions = [
    { value: 'th', label: 'Thai (Thailand)' },
    { value: 'en', label: 'English (Thailand)' },
    { value: 'my', label: 'English (Malaysia)' },
  ];

  switch (dbName) {
    // case 'MY':
    //   languageOptions = languageOptions.filter(option => option.value === 'my');
    //   break;
    case 'TH':
      languageOptions = languageOptions.filter(option => option.value !== 'my');
      break;
  }
  languageOptions = languageOptions.filter(option => option.value !== postLanguage);
  const [language, setLanguage] = useState(languageOptions[0].value);

  const languageOptionsElements = languageOptions.map(option => (
    <Option key={option.value} value={option.value}>
      {option.label}
    </Option>
  ));
  return (
    <StyledDuplicatePopup>
      <div className="post-info">
        <div className="post-info-header">
          <h2 className="post-title">Duplicate Post</h2>
        </div>
        <div className="post-info-body">
          <div className="language">
            <label>Language:</label>
            <div className="language-input">
              <Select
                value={language}
                style={{ width: '100%' }}
                onChange={value => setLanguage(value)}
              >
                {languageOptionsElements}
              </Select>
            </div>
          </div>
          <Checkbox checked={checked} onChange={e => setChecked(e.target.checked)}>
            Automatically replace inner links in post.
          </Checkbox>
        </div>
        <div className="post-info-footer">
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="default" onClick={handleDuplicate}>
            Duplicate
          </Button>
        </div>
      </div>
    </StyledDuplicatePopup>
  );
};

export default DuplicatePopup;
